module.exports = __webpack_public_path__ + "static/media/foto2.f8f1d529.png";